var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBaintexNameWhiteV1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 119.95,
    viewBox: "0 0 100 119.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_baintex_v1",
    transform: "translate(-2951.399 -228.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(2951.555 228.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M3032.534,328.147A19.566,19.566,0,0,1,3021,324.485c-3.481-2.341-7-4.619-10.537-6.883a28.914,28.914,0,0,0-5.8-2.97,9.588,9.588,0,0,0-6.952.192,37.936,37.936,0,0,0-6.656,3.634c-3.506,2.287-7,4.6-10.508,6.87a17.673,17.673,0,0,1-7.053,2.625,18.762,18.762,0,0,1-13.981-3.221,18.333,18.333,0,0,1-6.9-9.283,18.525,18.525,0,0,1-1.018-6.4,19.4,19.4,0,0,1,3.249-10.415q4.163-6.355,8.246-12.763a18.337,18.337,0,0,0,2.352-5.3,9.687,9.687,0,0,0-.526-6.1,40.09,40.09,0,0,0-3.8-6.884c-2.231-3.443-4.5-6.856-6.728-10.307a17.431,17.431,0,0,1-2.593-7.21A18.647,18.647,0,0,1,2955,236.54a18.364,18.364,0,0,1,8.829-6.82,18.994,18.994,0,0,1,8-1.152,19.2,19.2,0,0,1,9.41,3.257q5.694,3.767,11.438,7.461a24.622,24.622,0,0,0,5.473,2.768,9.541,9.541,0,0,0,3.744.6,10.761,10.761,0,0,0,4.4-1.253c2.349-1.307,4.684-2.65,6.955-4.083,3.317-2.084,6.542-4.311,9.867-6.38a15.309,15.309,0,0,1,6.424-2.183,23.81,23.81,0,0,1,4.363-.173,18.189,18.189,0,0,1,10.064,3.851,18.384,18.384,0,0,1,7.075,12.045,18.8,18.8,0,0,1-3.022,13.582c-2.306,3.5-4.614,6.988-6.876,10.5a36.459,36.459,0,0,0-3.274,6.116,9.774,9.774,0,0,0,.52,8.5c1.181,2.276,2.5,4.482,3.864,6.652,2.06,3.273,4.245,6.468,6.307,9.739a16.372,16.372,0,0,1,2.416,6.681,21.946,21.946,0,0,1,.265,3.662,18.772,18.772,0,0,1-14.235,17.7A16.321,16.321,0,0,1,3032.534,328.147Zm-31.148-55.7a2.178,2.178,0,0,0-.225-.355q-12.237-12.245-24.483-24.493a4.17,4.17,0,0,0-4.061-1.267,4.231,4.231,0,0,0-2.218,6.963c.411.459.875.878,1.312,1.321q6,5.994,12,11.993,5.679,5.661,11.345,11.334c.312.306.336.473.008.8q-12.163,12.152-24.322,24.311a4.3,4.3,0,0,0-1.362,3.843,4.217,4.217,0,0,0,7.16,2.33q12.2-12.188,24.382-24.393a6.433,6.433,0,0,0,.443-.547c.2.186.3.276.4.378q2.979,2.978,5.96,5.959l9.414,9.438c2.965,2.964,5.948,5.915,8.9,8.9a4.353,4.353,0,0,0,3.8,1.482,4.016,4.016,0,0,0,3.52-2.934,4.074,4.074,0,0,0-1.089-4.311q-10.526-10.538-21.053-21.053c-1.263-1.264-2.531-2.522-3.834-3.823.142-.121.26-.2.358-.3q12.246-12.245,24.494-24.488a4.1,4.1,0,0,0,1.277-3.5,4,4,0,0,0-2.8-3.549,3.892,3.892,0,0,0-4.308.938q-10.334,10.273-20.624,20.6C3004.342,269.458,3002.921,270.9,3001.386,272.447Z",
    transform: "translate(-2951.594 -228.523)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45",
    transform: "translate(2951.399 338.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M2962.677,370.761a3.51,3.51,0,0,1,1.179,1,2.3,2.3,0,0,1,.413,1.387,2.579,2.579,0,0,1-.271,1.179,2.718,2.718,0,0,1-.774.938,3.62,3.62,0,0,1-1.222.617,5.543,5.543,0,0,1-1.63.222H2951.4v-10.3h8.689a4.248,4.248,0,0,1,1.657.328,3.576,3.576,0,0,1,1.288.9,2.537,2.537,0,0,1,.694,1.748,2.347,2.347,0,0,1-.254,1.118A2.592,2.592,0,0,1,2962.677,370.761Zm-2.5-.938a1,1,0,0,0,.719-.292.983.983,0,0,0,.307-.747.905.905,0,0,0-.315-.716,1.168,1.168,0,0,0-.809-.28H2953.9v2.035Zm0,4.307a1.923,1.923,0,0,0,1.16-.29.965.965,0,0,0,.391-.818,1.113,1.113,0,0,0-.4-.883,1.665,1.665,0,0,0-1.11-.339H2953.9v2.33Z",
    transform: "translate(-2951.399 -365.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M2982.084,376.108l-1.181-2.218h-6.6l-1.179,2.218h-2.532l5.475-10.3h3.088l5.459,10.3Zm-4.494-8.418-2.262,4.223h4.522Z",
    transform: "translate(-2955.262 -365.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M2991.993,376.108v-10.3h2.5v10.3Z",
    transform: "translate(-2959.57 -365.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M3010.565,376.108l-6.982-7.351h-.041v7.351h-2.5v-10.3h2.916l6.982,7.367h.054v-7.367h2.506v10.3Z",
    transform: "translate(-2961.391 -365.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M3028.424,367.788v8.32h-2.5v-8.32h-4.906v-1.977h12.315v1.977Z",
    transform: "translate(-2965.412 -365.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M3040.815,376.108v-10.3h11.161v1.977h-8.659v2.106h6.014v1.978h-6.014v2.259h9.058v1.978Z",
    transform: "translate(-2969.398 -365.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M3069.585,376.108l-3.969-3.712-4.01,3.712h-3.328l5.632-5.219-5.446-5.078h3.328l3.8,3.572,3.81-3.572h3.328l-5.445,5.078,5.631,5.219Z",
    transform: "translate(-2972.913 -365.811)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBaintexNameWhiteV1);
export default __webpack_public_path__ + "static/media/logo_baintex_name_white_v1.f5f0a638f04b674e0997cf76b9cbe3a5.svg";
export { ForwardRef as ReactComponent };